import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const LinkedInBlueIcon = ({ ariaLabel = 'LinkedIn', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <rect width="32" height="32" rx="4" fill="#0C5BBA" />
      <rect x="3.77759" y="3.77778" width="24.4444" height="24.4444" fill="white" />
      <path
        d="M26.3271 26.3274H21.9807V19.5207C21.9807 17.8975 21.9517 15.8081 19.7202 15.8081C17.4564 15.8081 17.11 17.5765 17.11 19.4024V26.3269H12.7638V12.3295H16.9362V14.2424H16.9947C17.8443 12.7898 19.4297 11.919 21.1115 11.9814C25.5167 11.9814 26.329 14.879 26.329 18.6487L26.3271 26.3274ZM7.85961 10.4161C6.47593 10.4161 5.33681 9.27766 5.33681 7.89396C5.33681 6.51026 6.47541 5.37166 7.85909 5.37166C9.24264 5.37166 10.3811 6.51 10.3814 7.89344C10.3814 9.27688 9.24303 10.416 7.85961 10.4161ZM10.0327 26.3274H5.68188V12.3295H10.0327V26.3274ZM28.4938 1.33536H3.49773C2.32437 1.32211 1.34755 2.27624 1.33325 3.44961V28.5499C1.34703 29.7239 2.32371 30.6791 3.49773 30.6665H28.4938C29.6707 30.6813 30.6508 29.7263 30.6666 28.5499V3.44791C30.6508 2.27204 29.6694 1.31804 28.4938 1.33352V1.33536Z"
        fill="#0C5BBA"
      />
    </svg>
  );
};
